import { DomainModel } from 'domains/models';
import { DisplayType } from './displayType';

export const defaultIcon = () => {
  return 'earth_asia';
};

interface Props {
  teamId: number;
  uid: string;
  name: string;
  icon: string;
  canDelete: boolean;
  isDefaultAdd: boolean;
  displayType: DisplayType;
  sort: number;
  userId: string;
}

export default class Project extends DomainModel {
  teamId: number;
  uid: string;
  name: string;
  icon: string;
  canDelete: boolean;
  isDefaultAdd: boolean;
  displayType: DisplayType;
  sort: number;
  userId: string;

  constructor(props: Props) {
    super(props);
    this._className = 'Project';
    this.teamId = props.teamId;
    this.name = props.name;
    this.icon = props.icon;
    this.uid = props.uid;
    this.canDelete = props.canDelete;
    this.isDefaultAdd = props.isDefaultAdd;
    this.displayType = props.displayType;
    this.sort = props.sort;
    this.userId = props.userId;
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    let p = '';

    p = 'teamId';
    if (!scopes || scopes.includes(p)) {
      if (!this.teamId) {
        this.addError(p, 'E001');
      }
    }

    p = 'name';
    if (!scopes || scopes.includes(p)) {
      if (!this.name) {
        // this.addError(p, 'E001');
      } else {
        if (this.name.length > 64) {
          this.addError(p, 'E002');
        }
      }
    }

    p = 'uid';
    if (!scopes || scopes.includes(p)) {
      if (!this.uid) {
        this.addError(p, 'E001');
      }
    }

    p = 'icon';
    if (!scopes || scopes.includes(p)) {
      if (this.icon) {
      }
    }

    p = 'displayType';
    if (!scopes || scopes.includes(p)) {
      if (!this.displayType) {
        this.addError(p, 'E001');
      }
    }

    p = 'sort';
    if (!scopes || scopes.includes(p)) {
      // if (!this.sort) {
      //   this.addError(p, 'E001');
      // }
    }

    return super.isValid();
  }

  static permited = ['name', 'icon', 'sort', 'isDefaultAdd', 'displayType'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }
}
